import { PersistThings } from "../../persist/persistThings";
import { RuleSet } from "../../rules/ruleSet";
import { KeyMap } from "./keyToOrthoMapping";
import { OrthoRulesError } from "./serializeOrthoRules";
import { fonimRulesToVersionString, keyMapToVersionString, VersionError, versionStringToFonimKeyMap, versionStringToFonimRules } from "./versionFiles";

/** use local storage to load/save custom keys & rules */
export class PersistOrtho {
  private readonly persistKeys = new PersistThings('ortho/keys');
  private readonly persistRules = new PersistThings('ortho/rules');

  getSavedKeys(): string[] { return this.persistKeys.getSavedList(); }
  getSavedRules(): string[] { return this.persistRules.getSavedList(); }

  /** list of names that have both keys & rules */
  getSavedCommon(): string[] {
    const keys = this.getSavedKeys();
    const rules = this.getSavedRules();
    return keys.filter(k => rules.includes(k));
  }

  saveKeys(name: string, keys: KeyMap) {
    const thing = keyMapToVersionString(keys);
    this.persistKeys.saveThing(name, thing);
  }

  loadKeys(name: string): KeyMap | VersionError | null {
    const thing = this.persistKeys.loadThing(name);
    return thing === null ? null : versionStringToFonimKeyMap(thing);
  }

  deleteKeys(name: string) {
    this.persistKeys.deleteThing(name);
  }

  saveRules(name: string, ruleSet: RuleSet) {
    const thing = fonimRulesToVersionString(ruleSet);
    this.persistRules.saveThing(name, thing);
  }

  loadRules(name: string): RuleSet | OrthoRulesError | VersionError | null {
    const thing = this.persistRules.loadThing(name);
    return thing === null ? null : versionStringToFonimRules(thing);
  }

  deleteRules(name: string) {
    this.persistRules.deleteThing(name);
  }
}


const space = 'sp'; /** serialize ' ' as this to make it easier to parse */
const colon = 'col'; /** serialize ':' as this to make it easier to parse */

export function keyMapToString(keys: KeyMap): string {
  const keystrokes = Object.getOwnPropertyNames(keys);
  const mapping = keystrokes.map(k => {
    const key = k === ' ' ? space : k === ':' ? colon : k;
    const symbols = keys[k].join(' ');
    return `${key}: ${symbols}`;
  }).join('\n');
  return mapping;
}

export function stringToKeyMap(str: string): KeyMap {
  const map: KeyMap = {};
  const lines = str.split('\n');
  lines.forEach(line => {
    const pair = line.split(': ', 2); // split in two
    if (pair.length === 2) {
      const raw = pair[0];
      const key = raw === space ? ' ' : raw === colon ? ':' : raw;
      const list = pair[1].trim().split(' ').filter(s => s !== '');
      map[key] = list;
    }
  });
  return map;
}
